import { defineStore } from 'pinia';

function readString(key) {
  try {
    return localStorage.getItem(key) || '';
  } catch {
    return '';
  }
}

function readBoolean(value, fallback) {
  if (value === 'true') return true;
  if (value === 'false') return false;
  return fallback;
}

export const useDeviceStore = defineStore('device', {
  state: () => ({
    phoneToken: readString('phoneToken'),
    version: readString('appVersion'),
    versionCode: readString('appVersionCode'),
    isOnline: readBoolean(readString('isOnline'), typeof navigator !== 'undefined' ? navigator.onLine : true),
    isCordovaReady: false
  }),
  actions: {
    setPhoneToken(token) {
      const nextToken = String(token || '');
      this.phoneToken = nextToken;
      if (!nextToken) return;
      localStorage.setItem('phoneToken', nextToken);
    },
    setVersion(version) {
      const nextVersion = String(version || '');
      this.version = nextVersion;
      if (!nextVersion) return;
      localStorage.setItem('appVersion', nextVersion);
    },
    setVersionCode(versionCode) {
      const nextVersionCode = String(versionCode || '');
      this.versionCode = nextVersionCode;
      if (!nextVersionCode) return;
      localStorage.setItem('appVersionCode', nextVersionCode);
    },
    setOnline(value) {
      this.isOnline = Boolean(value);
      localStorage.setItem('isOnline', String(this.isOnline));
    },
    setCordovaReady(value) {
      this.isCordovaReady = Boolean(value);
    }
  }
});
